import config from "../config/config";
import { useContext } from 'react';
import { TeamsFxContext } from '../components/Context';
import { useApiMutation } from "./useApiMutation";
import { logger } from "../Logger";
import {LoadViewModelForEditingRequestData } from "../components/common/TcSOATypes";
import { MethodType } from "../types/ApiRequest";

/**
 * Get the declarative view model json for the loadEdit request for given business object.
 */
export const useLoadViewModelForEditing = () => {
  const teamsContext = useContext(TeamsFxContext);
  const mutation = useApiMutation<LoadViewModelForEditingRequestData[], any>({
    url: `${config.tcTeamsWebApiUrl}/loadeditdata`,
    method: MethodType.POST,
    key: "EDIT",
    enabled: teamsContext.teamcenter.isAuthenticated && !teamsContext.teamcenter.isAuthenticating,
    action: 'useLoadViewModelForEditing'
  }, logger);

  return mutation;
};
